import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { FilterAjTemplates } from 'containers/filters'
import { Modal } from 'containers/misc'
import { Button } from 'components/misc'
import { Data, Table } from 'components/layout/Table'
import { modal } from 'redux/modules/app'
import { ajTemplates as ajTemplatesLayout } from 'constants/layout'
import { apiAjTemplates } from 'helpers/decorators/api'

@connect(null, { modal })
@apiAjTemplates({
  list: true
})
class SelectAjTemplate extends Component {
  static propTypes = {
    modal: PropTypes.func,
    activities: PropTypes.object.isRequired,
    ajTemplates: PropTypes.object,
    change: PropTypes.func.isRequired
  }

  handleTemplateClick = ({
    ajEventCategory,
    location,
    awardLevel,
    activityCategory,
    country,
    otherLocationInformation,
    title,
    transportationModes
  }) => {
    const transportationModeList = transportationModes && transportationModes.map(item => {

      return {
        id: get(item, 'transportationMode.id'),
        value: get(item, 'transportationMode.modeOfTransportType.value'),
        label: get(item, 'transportationMode.modeOfTransportType.translationText')
      }
    })

    this.props.change('ajEventCategory.value', ajEventCategory.value)
    this.props.change(
      'activityCategory.parent.id',
      get(activityCategory, 'parent.id')
    )
    this.props.change('location', location)
    this.props.change('title', title)
    this.props.change('awardLevel.value', get(awardLevel, 'value'))
    this.props.change('activityCategory.id', get(activityCategory, 'id'))
    this.props.change('transportationModes', transportationModeList)
    this.props.change('country.id', get(country, 'id'))
    this.props.change('otherLocationInformation', otherLocationInformation)

    this.props.modal(null)
  }

  handleModalDisplay = () => {
    this.props.modal('aj-fill-from-template')
  }

  render() {
    const { ajTemplates, activities } = this.props

    return (
      <div>
        <span className="base-padding--right">
          <FormattedMessage
            id="ajTemplates.fill_from_template"
            defaultMessage="Fill from template"
          />
        </span>
        <Button type="button" onClick={() => this.handleModalDisplay()}>
          <FormattedMessage
            id="button.select_template"
            defaultMessage="Select template"
          />
        </Button>
        <Modal id="aj-fill-from-template">
          <FilterAjTemplates activities={activities} />
          <Table
            ths={ajTemplatesLayout.tableHeadersSimple}
            length={ajTemplates.list.length}
            selectable
          >
            <Data>
              {ajTemplates.list.map(item => (
                <tr
                  key={item.id}
                  onClick={() => this.handleTemplateClick(item)}
                >
                  <td>{get(item, 'id')}</td>
                  <td>{get(item, 'activityCategory.translatedName')}</td>
                  <td>{get(item, 'activityCategory.parent.translatedName')}</td>
                  <td>{get(item, 'location')}</td>
                </tr>
              ))}
            </Data>
          </Table>
        </Modal>
      </div>
    )
  }
}

export default SelectAjTemplate
